import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { CompanyWorkflowGendocProcessContainerModel } from "../../../../../../models";
import { BaseApiTemplateService, Core2Config } from "../../shared";

///core2/tnt/dm/erp/company-workflow-gendoc-process-template-hdrs/backoffice-ep
@Injectable({ providedIn: "root" })
export class CompanyWorkflowGendocProcessService extends BaseApiTemplateService<CompanyWorkflowGendocProcessContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX +  Core2Config.ERP_PREFIX + "company-workflow-gendoc-process-template-hdrs/backoffice-ep";
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX +  Core2Config.ERP_PREFIX + "company-workflow-gendoc-process-template-hdrs/backoffice-ep";
    this.httpClient = http;
  }
}
